import { Expose, Type } from 'class-transformer'
import { IsDefined, IsNumber, ValidateNested } from 'class-validator'
import { WarrantyGroup } from '../../entity'

export class WarrantyGrpoupsDTO {
    @Expose()
    @ValidateNested()
    @Type(() => WarrantyGroup)
    data!: WarrantyGroup[]

    @Expose()
    @IsDefined()
    @IsNumber()
    page!: number

    @Expose()
    @IsDefined()
    @IsNumber()
    pageSize!: number

    @Expose()
    @IsDefined()
    @IsNumber()
    count!: number
}
